import React from "react"
import { getAllRecipes, filterRecipesByDiet, orderByName, orderByHealthScore, orderByCreated, getNameRecipes} from "../actions";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "./Card";
import SearchBar from "./SearchBar";
import Paginado from "./Paginado";
import { Link } from "react-router-dom";
import s from "../componentsStlyes/Cards.module.css"
import c from '../componentsStlyes/Card.module.css'





export default function Home(){
    const dispatch = useDispatch(); // Cuando yo ponga algo dentro del dispatch, se despache automaticamente la accion dentro del parentesis
    //Tengo que traer el estado global usando el useselctor
    const recipes = useSelector(state=>state.recipes)
    //Indicar cuando se va a hacer el dispatch
    useEffect(()=>{ //  El parentesis es para invocar la funcion solo cuando es requerida. Al dispatch hay que pasarle la accion que quiero llevar a cabo
        dispatch(getAllRecipes()) 
    },[dispatch])//Pásarle la dependencia, un array vacia. Basicamente, la condicion que tiene para ejecutarse.


    const [currentPage, setcurrentPage] = useState(1)
    const [currentRecipes, setcurrentRecipes] = useState(9)
    const [orden, setOrden] = useState('')//Para handleFilterAlfabet
    const [score, setScore] = useState('')//ParaHandleFilterHealtscore
    const [name, setName] = useState('')//?
    const indexOfLastRecipe = currentPage * currentRecipes
    const indexOfFirstRecipe =  indexOfLastRecipe - currentRecipes

    const rendericedRecipes = recipes.slice(indexOfFirstRecipe,indexOfLastRecipe)
    


    const numberBotton = (e) =>{
        document.documentElement.scrollTop = 0;
        setcurrentPage(e)
    }
    function handleFilterDiet(e){
        // console.log('Se despacho la accion')
        e.preventDefault()
        setcurrentPage(1) //?
        dispatch(filterRecipesByDiet(e.target.value))
    }
    
    function handleFilterAlfabet(e){
        e.preventDefault()
        dispatch(orderByName(e.target.value))
        setcurrentPage(1); // Seteo la pagina principal en 1
        setOrden(`Ordenado ${e.target.value}`) //Cuando yo seteo la pagina, me modifique el estado local y se renderice
    }

    function handleFilterHealthscore(e){
        e.preventDefault();
        dispatch(orderByHealthScore(e.target.value))
        setcurrentPage(1);
        setScore(`Ordenado ${e.target.value}`)
    }

    function handleFilterByCreated(e){
        // console.log('Hice la funcion created')
        e.preventDefault();
        dispatch(orderByCreated(e.target.value))
        setcurrentPage(1);
        setOrden(`Ordenado ${e.target.value}`)
    }


    //Necesito guardar en mi estado local lo que hay en el input
    function handleInputChange(e){
        e.preventDefault()
        setName(e.target.value) //Tomo el valor del input y lo asigno al name
                          // console.log('Entre al handleInputChange')
    }
    function handleSubmit(e){
        e.preventDefault()
        dispatch(getNameRecipes(name)) //Este name va a ser mi estado local name, basicamente name es lo que esta escribiendo el usuario en el input
        // console.log('Entre a l handleSubmit')
        setcurrentPage(1)
    }


    return (      
        <div  className={s.container}>
            <nav className={s.nav}>
                <div className={s.navsuperior}>
                    <Link to='/recipe'>
                        <button className={s.crearReceta}>Create your recipe</button>
                    </Link>
                        <a href="/Cards" className={s.titulo}>¡Menús! </a>
                    <SearchBar handleInputChange={handleInputChange} handleSubmit={handleSubmit}/>
                 </div>
                <div className={s.selectores}>
                    <select className={s.botonSelectores} onChange={e=>handleFilterAlfabet(e)}>
                        <option value='asc'>Z-A</option>
                        <option value='desc'>A-Z</option>
                    </select>
                    <select className={s.botonSelectores} onChange={e=> handleFilterHealthscore(e)}>
                        <option value='score asc'>HealthScore Lower</option>
                        <option value='score desc'>HealthScore Higher</option>
                    </select>
                    <select className={s.botonSelectores} onChange={e=>handleFilterDiet(e)}>
                        <option value='all'>Types of diets</option>
                        <option value='gluten free'>Gluten Free </option>
                        <option value='dairy free'>Dairy Free </option>
                        <option value='ketogenic'>Ketogenic </option>
                        <option value='lacto ovo vegetarian'>Lacto Ovo Vegetarian </option>
                        <option value='vegan'>Vegan </option>
                        <option value='pescatarian'>Pescatarian </option>
                        <option value='paleolithic'>Paleolithic </option>
                        <option value='fodmap friendly'>FoodMap Friendly </option>
                        <option value='whole 30'>Whole 30 </option>
                        <option value='primal'>Prima </option>
                        <option value='vegetarian'>Vegetarian </option>
                    </select>
                    <select className={s.botonSelectores} onChange={handleFilterByCreated}>
                        <option value='all'> Created Or Api</option>
                        <option value='api'> Api</option>
                        <option value='create'>Created</option>
                    </select>
                </div>
            </nav>
                <div className={c.nav}>
                    {
                        rendericedRecipes.length>0 ? rendericedRecipes.map(r=>{
                            return(
                                    <div className={c.carta} key={r.id}>
                                        <Card healthScore={r.healthScore} title={r.title} image={r.image} diets={r.diets} id={r.id}/>
                                    </div>
                                )}
                                ) : <div className={s.error}> No se encontraron recetas </div>   
                            }
                </div>
                            <Paginado recipes={recipes} currentRecipes={currentRecipes} numberBotton={numberBotton}/> 
             </div>
    )
}

